import * as React from 'react';

import styles from './DeletedMessageLayout.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { ChatMessageBubble } from '../../../ChatMessageBubble';
import { ChatMessageRow } from '../../../ChatMessageRow';
import { MetaRow } from '../MetaRow';
import { IconActionBlock16 } from '@cian/ui-kit-design-tokens/icons';
import { Body1 } from '@cian/ui-kit';

interface IDeletedMessageLayoutProps {
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  messageMeta: React.ReactNode;
  userColor?: EUserColor;
  userName?: React.ReactNode;
  text: React.ReactNode;
}

export const DeletedMessageLayout = React.forwardRef<HTMLDivElement, IDeletedMessageLayoutProps>(
  function DeletedMessageLayout({ messageType, isLastMessageInChain, messageMeta, userColor, userName, text }, ref) {
    return (
      <ChatMessageRow>
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['deleted-message__bubble']}
          ref={ref}
          userColor={userColor}
        >
          {userName}
          <div className={styles['deleted-message__content']}>
            <IconActionBlock16 color="icon-inverted-disabled" />
            <Body1 color="text-inverted-disabled">{text}</Body1>
          </div>
          <MetaRow messageType={messageType} userColor={userColor}>
            {messageMeta}
          </MetaRow>
        </ChatMessageBubble>
      </ChatMessageRow>
    );
  },
);
